import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Webpack mangles Leaflet's default marker image paths — restore them.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

function ClickCapture({ onPick }) {
  useMapEvents({
    click(e) {
      onPick(Number(e.latlng.lat.toFixed(6)), Number(e.latlng.lng.toFixed(6)));
    },
  });
  return null;
}

/**
 * Tap-to-pin location picker (OpenStreetMap, no API key).
 * Props: lat, lng (numbers|null), onPick(lat, lng), height (px).
 */
export default function MapPicker({ lat, lng, onPick, height = 300 }) {
  const hasPin = typeof lat === 'number' && typeof lng === 'number' && !Number.isNaN(lat);
  const center = hasPin ? [lat, lng] : [-1.286389, 36.817223]; // Nairobi fallback

  return (
    <div className="rounded-lg overflow-hidden border border-gray-300 dark:border-gray-600">
      <MapContainer
        center={center}
        zoom={hasPin ? 14 : 11}
        style={{ height, width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        <ClickCapture onPick={onPick} />
        {hasPin && <Marker position={[lat, lng]} />}
      </MapContainer>
    </div>
  );
}
